import { useTranslation } from 'react-i18next';
// components
import { useSettingsContext } from '../components/settings';
//
import { allLangs, defaultLang } from './config';
import { useGlobalSettingsContext } from 'src/hooks/globalSettingsProvider';
import { CountryCode } from 'src/models/GlobalSetting';
import { useEffect } from 'react';

// ----------------------------------------------------------------------
export default function useLocales() {
  const { i18n, t: translate } = useTranslation();
  const { country } = useGlobalSettingsContext();
  const { onChangeDirectionByLang } = useSettingsContext();

  const isMXConfig = country.code === CountryCode.MX;
  const isESConfig = country.code === CountryCode.ES;

  // Para España: ES, EN, FR, DE, IT, BR, PT
  const langsForES = [
    allLangs.find(lang => lang.value === 'es'),
    allLangs.find(lang => lang.value === 'en'),
    allLangs.find(lang => lang.value === 'fr'),
    allLangs.find(lang => lang.value === 'de'),
    allLangs.find(lang => lang.value === 'it'),
  //  allLangs.find(lang => lang.value === 'br'),
    allLangs.find(lang => lang.value === 'pt'),
  ].filter(Boolean);

  // Para México: MX, US (alias EN), BR (alias PT), FR, IT
  const langsForMX = [
    allLangs.find(lang => lang.value === 'es_mx'),
    {
      label: 'English',
      value: 'us', // alias para México
      systemValue: allLangs.find(lang => lang.value === 'en')?.systemValue,
      icon: allLangs.find(lang => lang.value === 'en')?.icon,
      showLabel: 'US',
    },
    allLangs.find(lang => lang.value === 'fr'),
    allLangs.find(lang => lang.value === 'it'),
    allLangs.find(lang => lang.value === 'br'),
    //allLangs.find(lang => lang.value === 'pt'),
  ].filter(Boolean);

  // Seleccionar lista según país
  const currentLangList = isMXConfig
    ? langsForMX
    : isESConfig
    ? langsForES
    : allLangs;

  const langStorage = typeof window !== 'undefined' ? localStorage.getItem('i18nextLng') : '';

  // Funciones para mapear alias y valores reales (simplificado para br y pt)
  const aliasToRealLang = (alias: string) => {
    if (alias === 'us') return 'en';  // Alias para inglés en México
    return alias;  // Sin alias para br y pt
  };

  const realToAliasLang = (real: string) => {
    if (isMXConfig) {
      if (real === 'en') return 'us';
    }
    return real;
  };

  // Mapear langStorage (real) a alias para encontrar currentLang en la lista con alias
  const mappedLangStorage = realToAliasLang(langStorage || '');

  // Si idioma guardado no está en la lista, usar el primer idioma (default)
  const currentDefaultLang = currentLangList[0];
  const currentLang =
    currentLangList.find((_lang) => _lang?.value === mappedLangStorage) || currentDefaultLang;

  useEffect(() => {
    const langInStorage = localStorage.getItem('i18nextLng');

    if (!langInStorage) {
      if (isMXConfig) {
        handleChangeLanguage('es_mx');
      } else if (isESConfig) {
        handleChangeLanguage('es');
      }
    }
  }, []);

  const handleChangeLanguage = (newlang: string) => {
    // Mapear alias a valores reales que entiende i18n
    const langToUse = aliasToRealLang(newlang);

    i18n.changeLanguage(langToUse);
    onChangeDirectionByLang(langToUse);
  };

  return {
    onChangeLang: handleChangeLanguage,
    translate: (text: any, options?: any) => translate(text, options),
    currentLang,
    allLangs: currentLangList,
  };
}
